import { useMutation } from '@tanstack/react-query';
import request from '@/services/api';

export const useFileUpload = (url = '/file') => {
  const mutation = useMutation({
    mutationFn: async (fileData: File | FormData) => {
      let payload: FormData;
      if (fileData instanceof FormData) {
        payload = fileData;
      } else {
        payload = new FormData();
        payload.append('file', fileData);
      }
      const res = await request.post(url, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    },
  });

  return {
    ...mutation,
    triggerFileUpload: mutation.mutateAsync,
  };
};
